<!--
<button class="btn btn-lg btn-outline-primary" (click)="open()">Launch demo offcanvas</button>
&lt;!&ndash; TODO: Add sidebar for mobile, offcanvas for mobile &ndash;&gt;
<div class="d-flex">
  <div class="w-300 d-none d-md-block" ><app-sidebar></app-sidebar></div>
  <div class="flex-grow-1">
    <router-outlet></router-outlet>
  </div>
</div>
-->
<!--
<div id="meetContainer">
  <div id="meetHeader"></div>
  <div class="meet-content">
    <router-outlet></router-outlet>
  </div>
</div>
-->
@if ({ value: desktop$ | async }; as isDesktop) {
  @if (isDesktop.value) {
    <app-sidebar [meet]="currentMeet"></app-sidebar>
  }
  @if (!isDesktop.value) {
    <app-mobile-sidebar [meet]="currentMeet"></app-mobile-sidebar>
  }
}
<div #container id="meetContainer">
  <div id="meetHeader"></div>
  <div class="meet-content">
    @if (loading) {
      <div class="loading-the-meet">
        <fa-icon [icon]="environment.icons.spinner" [fixedWidth]="true" animation="spin"></fa-icon>&nbsp;<ng-container
          i18n="Explain that the meet is currently loading@@meet.loading"
          >Loading the meet</ng-container
        >
      </div>
    }
    <router-outlet></router-outlet>
  </div>
  <div class="meet-content--main-column">
    @if (currentMeet) {
      <div class="meet-content" style="min-height: 0">
        @if (currentMeet.videoLink) {
          <div class="d-grid mb-3">
            <a target="_blank" href="{{ currentMeet.videoLink }}" class="btn btn-primary btn-lg btn-block">
              <strong
                ><fa-icon [icon]="environment.icons.video" [fixedWidth]="true"></fa-icon>&nbsp;
                <span i18n="@@meet.watchLive">Watch Live</span></strong
              >
            </a>
          </div>
        }
        @if (currentMeet.timerName || currentMeet.questionsEmail || currentMeet.questionsName) {
          <div class="card">
            <div class="card-body">
              @if (currentMeet.timerName) {
                <ng-container i18n="@@meet.timedBy">Timed by</ng-container>&nbsp;{{ currentMeet.timerName }}.
              }
              @if (currentMeet.questionsName) {
                @if (currentMeet.questionsEmail) {
                  <ng-container i18n="@@meet.sendQuestionsTo"> Please email results questions to </ng-container>
                  {{ currentMeet.questionsName }}
                  (<a href="mailto:{{ currentMeet.questionsEmail }}">{{ currentMeet.questionsEmail }}</a
                  >).
                } @else {
                  <ng-container i18n="@@meet.sendQuestionsTo2"> Please email results questions to </ng-container
                  >{{ currentMeet.questionsName }}.
                }
              }
            </div>
          </div>
        }
        <app-site-footer></app-site-footer>
      </div>
    } @else if (!loading) {
      <div class="meet-content" style="min-height: 0">
        <app-site-footer></app-site-footer>
      </div>
    }
  </div>
</div>
<app-footer-menu class="d-lg-none" [meet]="currentMeet"></app-footer-menu>
